import { useEffect, useState } from "react"
import { arrayOf, shape, number, object } from "prop-types"
import { Button, StackView } from "@planningcenter/tapestry-react"
import AttendeeCheckbox from "./AttendeeCheckbox"
import PromoteCapacityWarning from "./PromoteCapacityWarning"
import useApiClient from "hooks/use_api_client"
import { isBlank } from "utils/helpers"

const WaitlistedAttendees = ({ attendees, registration, event }) => {
  const [loading, setLoading] = useState(false)
  const [selectedAttendeeIds, setSelectedAttendeeIds] = useState([])
  const handleSelect = id => {
    return event => {
      if (event.target.checked) {
        setSelectedAttendeeIds(currentIds => [...new Set([...currentIds, id])])
      } else {
        setSelectedAttendeeIds(currentIds => currentIds.filter(currentId => currentId !== id))
      }
    }
  }

  // If attendees changes, update selectedAttendees to only include those that are still in the list
  useEffect(() => {
    setSelectedAttendeeIds(currentIds =>
      currentIds.filter(id => attendees.some(attendee => attendee.id === id))
    )
  }, [attendees])

  const anyAttendeesChecked = selectedAttendeeIds.length > 0

  const api = useApiClient("registrations")

  const eventCapacity = isBlank(event.maximumCapacity)
    ? Infinity
    : event.maximumCapacity - event.currentActiveAttendees
  const findAttendee = attendeeId => attendees.find(attendee => attendee.id === Number(attendeeId))
  const findAttendeeType = attendeeTypeId =>
    event.attendeeTypes.find(attendeeType => attendeeType.id === Number(attendeeTypeId))
  const selectedAttendeeTypeCount = attendeeTypeId =>
    selectedAttendeeIds.filter(attendeeId => {
      const attendee = findAttendee(attendeeId)
      return attendee?.attendeeTypeId === attendeeTypeId
    }).length
  console.log("selectedAttendeeIds", selectedAttendeeIds)

  const selectedAttendeesExceedCapacity =
    selectedAttendeeIds.length > eventCapacity ||
    selectedAttendeeIds.some(attendeeId => {
      const attendee = findAttendee(attendeeId)
      const attendeeType = findAttendeeType(attendee?.attendeeTypeId)
      const availableCapacity = isBlank(attendeeType?.available_capacity)
        ? Infinity
        : attendeeType.available_capacity
      return selectedAttendeeTypeCount(attendee.attendeeTypeId) > availableCapacity
    })

  const handleWaitlistPromotion = () => {
    setLoading(true)
    return api
      .post({
        url: `/registrations/${registration.id}/promote_waitlist`,
        data: {
          attendee_ids: selectedAttendeeIds
        }
      })
      .then(_ => {
        return Turbolinks.visit()
      })
  }

  return (
    <>
      <div className="d-f ai-c jc-sb mb-2">
        <h1 className="h4 fw-600 mb-0">Waitlist</h1>
        <div className="d-f ai-c fw-w" css={{ gap: "0.5rem" }}>
          {selectedAttendeesExceedCapacity && (
            <PromoteCapacityWarning count={selectedAttendeeIds.length} />
          )}
          <Button
            title="Promote"
            size="xs"
            theme="create"
            variant="outline"
            disabled={!anyAttendeesChecked}
            spinner={loading}
            onClick={handleWaitlistPromotion}
          />
        </div>
      </div>
      <StackView gap={2}>
        {attendees.map(attendee => (
          <AttendeeCheckbox
            key={attendee.id}
            attendee={attendee}
            checked={selectedAttendeeIds.includes(attendee.id)}
            onSelect={handleSelect(attendee.id)}
          />
        ))}
      </StackView>
    </>
  )
}

WaitlistedAttendees.propTypes = {
  attendees: arrayOf(
    shape({
      id: number
    })
  ),
  registration: shape({
    id: number
  }),
  event: object
}

export default WaitlistedAttendees
